export default __webpack_public_path__ + "static/ef-diferencial-img-2-7cee691ae10c8b4074511c84be68a959.png";